import notify from 'components/atoms/Notify'
import apiPut from 'lib/network/apiPut'
import React, { useState } from 'react'
import Selection from 'components/molecules/Selection'
import { useTranslation } from 'react-i18next'

const UpdateTransactionStatusModal = ({ transaction, onSuccess, close }) => {
  const { t } = useTranslation()
  console.log('transaction', transaction.status)

  const transactionStatusOptions = [
    { id: 'initiated', name: t('transactionModal.statusOptions.initiated') },
    { id: 'completed', name: t('transactionModal.statusOptions.completed') },
    { id: 'canceled', name: t('transactionModal.statusOptions.canceled') },
    { id: 'waiting_for_payment_approval', name: t('transactionModal.statusOptions.waitingForPaymentApproval') },
  ]

  // eslint-disable-next-line
  const defaultStatus = transactionStatusOptions.find(opt => opt.id === transaction?.status) || null
  const [selectedStatus, setSelectedStatus] = useState(defaultStatus)
  const [isLoading, setIsLoading] = useState(false)

  const handleUpdateStatus = async () => {
    if (!selectedStatus) {
      notify.error(t('transactionModal.messages.selectStatus'))
      return
    }

    if (selectedStatus.id === transaction.status) {
      notify.error(t('transactionModal.messages.selectDifferentStatus'))
      return
    }

    setIsLoading(true)
    try {
      const response = await apiPut(`transactions/${transaction._id}/status`, {
        status: selectedStatus.id,
      })

      if (response.success) {
        notify.success(t('transactionModal.messages.statusUpdatedSuccess'))
        if (onSuccess) onSuccess(response.data)
        close()
      }
    } catch (error) {
      console.error('Error updating transaction status:', error)
      notify.error(error?.message || t('transactionModal.messages.updateFailed'))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="">
      <div className="mb-6">
        <label htmlFor="transactionStatus" className="block text-sm font-normal text-gray-700 mb-1">
          {t('transactionModal.form.transactionStatus')}
        </label>

        <Selection
          onChange={value => {
            setSelectedStatus(value)
          }}
          title={t('transactionModal.form.selectStatus')}
          list={transactionStatusOptions}
          value={selectedStatus?.id || ''}
          className="w-full"
        />
      </div>

      <div className="flex justify-end">
        <button
          onClick={handleUpdateStatus}
          disabled={isLoading || !selectedStatus}
          className="px-4 py-2 text-sm font-medium text-white bg-dark-600 rounded-md hover:bg-dark-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? t('transactionModal.buttons.updating') : t('transactionModal.buttons.updateStatus')}
        </button>
      </div>
    </div>
  )
}

export default UpdateTransactionStatusModal
